
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mobile-plan-comparison",
      function () {
        return require("private-next-pages/mobile-plan-comparison/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mobile-plan-comparison"])
      });
    }
  